// extracted by mini-css-extract-plugin
export default {"container":"InputContainer_container__i4JMJ","input":"InputContainer_input__9GOPk","label":"InputContainer_label__QWad-"};